import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { routes } from '../routes';
import Nav from './Nav';
import css from './Header.css';

const logo = 'https://admin.elocker.cl/static/elocker%20logo%20web-2.png';

const Header = ({ location, user, actions }) => {
  return (
    <header className={css.root}>
      <h1 className={css.logo}>
        <Link to={routes('root')}>
          <img src={logo} alt="eLocker" />
        </Link>
      </h1>
      {user.id && <Nav className={css.nav} current={location.pathname} user={user} logout={actions.logout} />}
    </header>
  );
};

export default withRouter(Header);
